import React, { useState, useEffect, Fragment } from 'react';
import { Row, CardHeader, Nav, NavItem, NavLink, Button, TabContent, FormGroup, Label, TabPane, Card, CardBody, Input } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Orders_Voucher, gAPI_Internal_Property_By_Id,
   gAPI_VisitorsGroupsContact_Stats, API_Ingetration, API_Order_Voucher_Pdf,
    gAPI_Vouchers, API_EmbedVoucher_Connection } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ViewOrders from './Components/ViewOrders';
import Statement from '../statements/index';
import moment from 'moment';
import { RotateSpinner } from 'react-spinners-kit';
import OrderList from './Components/OrderList';
import OrderInfo from './Components/OrderInfo';
import UpdateStatus from './Components/UpdateStatus';
import DatePicker from 'react-datepicker';
import classnames from 'classnames';
import Contact from '../../../dashboards/components/cards/Contact';
import Select from 'react-select';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import PreviewVoucherList from './Components/PreviewVoucherList';
import Axios from 'axios';
import { NotificationManager } from '../../../../../components/common/react-notifications';
const dataTableColumnsContacts = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Email',
    accessor: 'email',
    Cell: (props) => (
      <p className="">
        {props.value}
        <span
          className="text-muted ml-1"
          style={{ cursor: 'pointer' }}
        // onClick={handleMaskClick}
        >
          {props.value}
        </span>
      </p>
    ),
  },
  {
    Header: 'Phone',
    accessor: 'phone',
    Cell: (props) => (
      <p className="">
        {props.value}
        <span
          className="text-muted ml-1"
          style={{ cursor: 'pointer' }}
        //onClick={handleMaskClick}
        >
          {props.value}
        </span>
      </p>
    ),
  },
  {
    Header: 'Zip Code',
    accessor: 'zipCode',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Marketing Consent',
    accessor: 'consent',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Date',
    accessor: 'consentDate',
    Cell: (props) => (
      <p className="">
        {props.value !== '' ? moment(props.value).format('lll') : ''}
      </p>
    ),
  },
];

function Index({ propertyId, user }) {
  const [startDate, setStartDate] = useState(moment().subtract(5, 'days'));
  const [endDate, setEndDate] = useState(moment());
  const [loading, setLoading] = useState(true);
  const [orderList, setOrderList] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [orderId, setOrderId] = useState('');
  const [showOrderData, setShowOrderData] = useState(false);
  const [showOrdeList, setShowOrderList] = useState(false);
  const [showStatement, setShowStatement] = useState(false);
  const [searchOrder, setSearchOrder] = useState("");
  const [currency, setCurrency] = useState("");
  const [websiteIntregationId, setWebsiteIntregationId] = useState('');
  const [reportingTags, setReportingTags] = useState([]);
  const [activeTab, setActiveTab] = useState("orders");
  const [contactStatsData, setContactStatsData] = useState([]);
  const [propertyData, setPropertyData] = useState('');
  const [status, setStatus] = useState('All');
  const [selectedReportingTags, setSelectedReportingTags] = useState({});
  const [vouchers, setVouchers] = useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Level: 'Group',
    Properties:[propertyId],
    SessionTimeoutInSeconds: 600,
    BaseUrl: 'https://www.bookmebob.com',
    HomePageRoute: '/',
    DefaultLanguage: 'en-US',
    DefaultRuleDescription: 'Default',    
    layoutType:0,arrowType:0,arrowSize:40,arrowColor:'black',
    colours:{title:'',subtitle:'',arrow:'black',       primaryColor:'#E31B78',
    buttonColor: '#033DA5',
    redeemBar:'#FA8DAB',
    redeemButton:'#F5D2E3',
    buttonTextColor:'white',
    redeemTextColor:'black',
    shoppingBar:'#ED187B',
    shoppingBarText:'white'},
    isFooterHide:false
  });
  const handleSearchfilterDate = date => {
    setStartDate(date);
    onstartDateChange(date);
  };
  const handleSearchfilterEndDate = date => {
    setEndDate(date);
    onEndDateChange(date);
  };

  const onstartDateChange = (date) => {
    setStartDate(date);
  };

  const currencyFormat = (currency, value) =>
    new Intl.NumberFormat('en-US', {
      style: "currency",
      currency: currency,
    }).format(value);

  const onEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleReportingTags = (selectedTags) => {
    setSelectedReportingTags(selectedTags);
  };
  const LoadData = (startdate, enddate) => {
    setOrderList([]);    
    let fromDate = startdate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
    let toDate = enddate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}?fromDate=${fromDate}&toDate=${toDate}&groupId=${getGroupID()}&propertyId=${propertyId}`,
    })
      .then(res => {

        let options = [];
        let reportingOptions = [];

        if (res.data.length > 0) {
          if (status !== 'All')
            res.data = res.data.filter((f) => f.redeem === status)
          if (reportingTags.length > 0)
            res.data = res.data.filter((f) => f.reportingTags.includes(reportingTags))
          res.data.map((m) => {
            if (m.reportingTags !== undefined && m.reportingTags !== null && m.reportingTags.length > 0) {
              m.reportingTags.map((n) => {
                if (reportingOptions.filter((f) => f.value === n).length === 0) {
                  reportingOptions.push({
                    label: n,
                    value: n,
                    key: n
                  });
                }
              });
            }
          })
          setReportingTags(reportingOptions);
          setOrderId(res.data[0].voucherNumber);
        }
        setOrderList(res.data);
        setLoading(false);
        setShowOrderList(true);
      })
      .catch(err => console.log('err', err));
  }
  const handleSubmit = (startdate, enddate) => {
    setOrderList([]);
    let fromDate = startdate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
    let toDate = enddate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}?fromDate=${fromDate}&toDate=${toDate}&groupId=${getGroupID()}&propertyId=${propertyId}`,
    })
      .then(res => {

        if (res.data.length > 0) {
          if (status !== 'All')
            res.data = res.data.filter((f) => f.redeem === status);
          if (res.data.length > 0 && selectedReportingTags.value !== undefined)
            res.data = res.data.filter((m) => m.reportingTags.includes(selectedReportingTags.value) === true);
        }
        setOrderId(res.data[0].voucherNumber);
        setOrderList(res.data);
        setLoading(false);
        setShowOrderList(true);
      })
      .catch(err => console.log('err', err));
  }
  const LoadSearchOrderData = (search, status) => {
    setOrderList([]);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}/search?status=${status}&search=${search}&groupId=${getGroupID()}&propertyId=${propertyId}`,
    })
      .then(res => {
        setOrderList(res.data);
        setLoading(false);
      })
      .catch(err => console.log('err', err));
  }

  const OrderData = (id) => {
    setOrderData([]);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}/detail?orderId=${id}`,
    })
      .then(res => {
        setOrderData(res.data.items);
      })
      .catch(err => console.log('err', err));
  }

  const handleCurrency = (currency) => {
    try {
      if (currency === "AUD") {
        currency = currencyFormat("AUD", 0)
          .replace(/[A-Za-z]/g, "")
          .charAt(currencyFormat("AUD", 0).indexOf("$") - 1);
        return currency;
      } else if (currency === "NZD") {
        currency = currencyFormat("NZD", 0)
          .replace(/[A-Za-z]/g, "")
          .charAt(currencyFormat("NZD", 0).indexOf("$") - 2);
        return currency;
      } else if (currency === "PHP") {
        currency = currencyFormat(currency, 0)
          .replace(/[A-Za-z]/g, "")
          .substring(0, 1);
        return currency;
      } else if (currency === "EUR") {
        currency = currencyFormat(currency, 0)
          .replace(/[A-Za-z]/g, "")
          .substring(0, 1);
        return currency;
      } else if (currency === "MYR") return "RM";
      else if (currency === "ISK") return "kr";
      else if (currency === "MYR") return "RM";
      else if (currency === "ISK") return "kr";
      else if (currency === "AED") {
        return "فلس";
      } else {
        currency = currencyFormat(currency, 0)
          .replace(/[A-Za-z]/g, "")
          .substring(0, 1);
        return currency;
      }
    } catch {
      currency = currencyFormat("NZD", 0)
        .replace(/[A-Za-z]/g, "")
        .charAt(currencyFormat("NZD", 0).indexOf("$") - 2);
      return currency;
    }
  };

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId
        }?group_id=${getGroupID()}`,
    }).then(propData => {        
        let property = [];
        property.push(propData.data);
        setPropertyData(propData.data);        
        try {          
          if (property[0].currency === "AUD")
            setCurrency(currencyFormat("AUD", 0)
              .replace(/[A-Za-z]/g, "")
              .charAt(currencyFormat("AUD", 0).indexOf("$") - 1));
          else
            setCurrency(currencyFormat(property[0].currency, 0)
              .replace(/[A-Za-z]/g, "")
              .substring(
                0,
                currencyFormat(property[0].currency, 0).indexOf("0") - 2
              ));
        } catch {
          currency=propData.data.currency;
          setCurrency(currencyFormat("NZD", 0)
            .replace(/[A-Za-z]/g, "")
            .charAt(currencyFormat("NZD", 0).indexOf("$") - 2));
        }
        loadIntegration(propData.data.currency);
      });
    
    LoadData(startDate, endDate);
  }, [propertyId]);

  const loadOrderVoucherpdf = (orderVoucher) => {
    NotificationManager.success(
      '',
      'Please wait, it will take a few moments to download the PDF',
      3000,
      null,
      null,
      'success'
    );
    AxiosAPI({
      method: 'GET',
      url: `${API_Order_Voucher_Pdf}?voucher_number=${orderVoucher}`
    })
      .then(response => {
        // var pdfAsDataUri = "data:application/pdf;base64," + response.data.content;
        // window.open(pdfAsDataUri);
        let link=document.createElement('a');
        const mimeType = "application/pdf";
        link.href=`data:${mimeType};base64,${response.data.content}`;
        link.download=`${orderVoucher}.pdf`;
        link.click();
      })
      .catch(error => {
        console.log(error);
      });
  }

  const loadIntegration=(currency)=>{    
    localStorage.removeItem("currentCartVouchers");
    localStorage.removeItem("currentCartItemLength");
    let body={
      channels:['EmbedVoucher']
    }
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body
    }).then((res) => {
      const webIntegrationData = res.data.filter(
        (k) => k.channel === 'EmbedVoucher' && k.disabled === false && k.properties !== undefined && k.properties.includes(propertyId)
      );                
      if (webIntegrationData.length > 0)
        setWebsiteIntregationId(webIntegrationData[0].id);
      else {
       AddIntegration();
      }
      if (webIntegrationData.length === 1){
      AxiosAPI({
        method: "get",
        url: `${gAPI_Vouchers}?groupId=${getGroupID()}&integration_id=${webIntegrationData[0].id}&propertyId=${propertyId}&languageCode=en&search=&status=Active&pageNumber=1&pageSize=10000&currency=${currency}`,
      })
        .then((res) => {          
          setVouchers(res.data.vouchers);
        });
      }

    });
  };

  const AddIntegration=()=>{
    Axios.all([  
      AxiosAPI({
        method: 'post',
        url: `${API_EmbedVoucher_Connection}`,
        data: inputData,
      }),
    ]).then(() =>{   
      let body={
        'channels':['EmbedVoucher']
      };
      AxiosAPI({
        method: 'post',
        url: `${API_Ingetration}?group_id=${getGroupID()}`,
        data: body
      }).then((res) => {
        const webIntegrationData = res.data.filter(
          (k) => k.channel === 'EmbedVoucher' && k.disabled === false && k.properties !== undefined && k.properties.includes(propertyId)
        );                  
        if (webIntegrationData.length === 1)
          setWebsiteIntregationId(webIntegrationData[0].id);
        else {
         
        }
        if (webIntegrationData.length === 1){
        AxiosAPI({
          method: "get",
          url: `${gAPI_Vouchers}?groupId=${getGroupID()}&integration_id=${webIntegrationData[0].id}&propertyId=${propertyId}&languageCode=en&search=&status=Active&pageNumber=1&pageSize=10000&currency=${propertyData.currency}`,
        })
          .then((res) => {          
            setVouchers(res.data.vouchers);
          });
        }
  
      });       
  });
  };

  const handleContacts = (startdate, enddate) => {
    let fromDate = startdate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
    let toDate = enddate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
    AxiosAPI({
      method: 'get',
      url: `${gAPI_VisitorsGroupsContact_Stats}`,
      params: {
        groupId: getGroupID(),
        dateFrom: fromDate,
        dateTo: toDate,
        propertyId: propertyId,
      },
    }).then((res) => {
      setContactStatsData(res.data);
    });
  };

  return (
    <Fragment>
      <CardHeader style={{ marginLeft: '-1.25rem', marginRight: '-1.25rem' }}>
        <Nav tabs className="card-header-tabs ml-0 mr-0">
          <NavItem className=" text-center" style={{ width: 'auto', background: '' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === "orders",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("orders");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "orders" ? '#EF4A81' : 'black'}` }}>Order History</span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === "statement",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("statement");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "statement" ? '#EF4A81' : 'black'}` }}>Statement</span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === "contacts",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("contacts");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "contacts" ? '#EF4A81' : 'black'}` }}>Contacts</span>
            </NavLink>
          </NavItem>
          {websiteIntregationId !== '' &&   <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === "sell",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("sell");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "contacts" ? '#EF4A81' : 'black'}` }}>Sell Vouchers</span>
            </NavLink>
          </NavItem>}
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab} className="">
        <TabPane tabId="orders" className="chat-app-tab-pane">
          <Card className="mb-4">
            <CardBody>
              {showStatement !== undefined && showStatement === false &&
                <Row className="col-md-12">
                  <Fragment>
                    <Colxx xxs="12" md="2" className="mb-2">
                      <FormGroup><Label>Start Date</Label>
                        <DatePicker
                          selected={startDate}
                          onChange={handleSearchfilterDate}
                          placeholderText="Start Date"
                          dateFormat="DD/MM/YYYY"
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx xxs="12" md="2" className="mb-2">
                      <FormGroup><Label>End Date</Label>

                        <DatePicker
                          selected={endDate}
                          onChange={handleSearchfilterEndDate}
                          placeholderText="End Date"
                          dateFormat="DD/MM/YYYY"
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Status</Label>
                      <Input
                        type="select"
                        value={status}
                        name="status"
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="All">All</option>
                        <option value="NotRedeemed">Available</option>
                        <option value="Redeem">Redeem</option>
                        <option value="Void">Void</option>
                        <option value="Refund">Refund</option>
                      </Input>
                    </Colxx>
                    <Colxx sm={4}>
                      <FormGroup>
                        <Label for="bookingUrl">Internal Reporting Tags</Label>
                        <Select
                          components={{ Input: CustomSelectInput }}
                          className="react-select"
                          classNamePrefix="react-select"
                          isMulti={false}
                          name="form-field-name"
                          value={selectedReportingTags}
                          onChange={handleReportingTags}
                          options={reportingTags}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx xxs="12" md="1" className="mb-2 mt-3">
                      <Button
                        color="primary"
                        className="mb-2"
                        onClick={() => { handleSubmit(startDate, endDate); }}
                      >
                        Submit
                      </Button>
                    </Colxx>
                    <Colxx xxs="12" md="10" className="mb-2"></Colxx>
                    <Colxx xxs="12" md="2" className="text-right mb-2">
                      <div className="search-sm d-inline-block mb-1 align-top">
                        <Input value={searchOrder} className="form-control" placeholder="Search" onChange={(e) => {
                          setSearchOrder(e.target.value);
                          LoadSearchOrderData(e.target.value, 'All');
                        }}></Input>     
                    </div>
                    </Colxx>

                  </Fragment>
                </Row>}
              {showStatement !== undefined && showStatement === false &&
                <Row className='ml-1'>
                  <OrderList currency={currency} hanldeOrderId={(id) => setOrderId(id)} orderId={orderId} data={orderList}></OrderList>

                  {orderId !== undefined && orderId !== '' && orderList.length > 0 &&
                    orderList.filter(f => f.voucherNumber === orderId)[0] !== undefined && orderList.filter(f => f.voucherNumber === orderId)[0] !== null &&
                    <Fragment>
                      <OrderInfo loadOrderVoucherpdf={loadOrderVoucherpdf} data={orderList.filter(f => f.voucherNumber === orderId)[0]}></OrderInfo>
                      <UpdateStatus handleReload={handleSubmit} user={user} data={orderList.filter(f => f.voucherNumber === orderId)[0]} orderId={orderId} handleOrder={() => handleSubmit(startDate, endDate)}></UpdateStatus>
                    </Fragment>
                  }
                </Row>
              }
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="sell" className="chat-app-tab-pane">
          <Card className="mb-4">
            <div
              className="row splide__list my-2 pb-4"
              style={{ justifyContent: "center" }}
            >
              {vouchers.length > 0 &&
                vouchers.filter(f=>(f.status==='Active' || f.status === 'ActiveMembers') && f.currency === propertyData.currency && f.isAds === false).map((v, index) => {      
                  if(v.status ==='Active' || v.status === 'ActiveMembers'){          
                    return (
                      <div
                        key={v.id + index}
                        onClick={() =>   window.parent.postMessage("embed_voucher_image:" + v.id, "*")}
                        className="width-new-20 my-3"
                      >
                        <div
                          className="card card-experience"                       
                        >
                          <div className="card-image-container">
                            <img className="card-img-top" src={v.images.length > 0 && v.images[0].url}></img>
                          </div>
                          {v.discount > 0 && (
                            <Fragment>                            
                                <div
                                  className="discountcustom"                               
                                >
                                  <div className="cartItem">
                                    <Fragment>
                                      {" "}
                                      {v.discount}%<span>OFF</span>
                                    </Fragment>
                                  </div>
                                </div>                              
                            </Fragment>
                          )}
                          <div className="card-body">
                            <h6>{v.isCard !== true ? handleCurrency(v.currency) + v.discountedPrice : ( handleCurrency(v.currency) + v.minAmount.toLocaleString('en-US') + " -" + handleCurrency(v.currency) + v.discountedPrice.toLocaleString('en-US'))}</h6>
                            <h6 className="card-experience__title">{v.name}</h6>
                          </div>
                        </div>
                      </div>
                    );                  
                }
                })}
            </div>
            {websiteIntregationId !== '' && <PreviewVoucherList iid={websiteIntregationId} gid={getGroupID()} pid={propertyId}></PreviewVoucherList>}
          </Card>
        </TabPane>
        <TabPane tabId="statement" className="chat-app-tab-pane">
          <Card className="mb-4">
            <CardBody>
              <Statement></Statement>
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="contacts" className="chat-app-tab-pane">
          <Card className="mb-4">
            <Row className="col-md-12 mt-3">
              <Fragment>
                <Colxx xxs="12" md="2" className="mb-2">
                  <DatePicker
                    selected={startDate}
                    onChange={handleSearchfilterDate}
                    placeholderText="Start Date"
                    dateFormat="DD/MM/YYYY"
                  />
                </Colxx>
                <Colxx xxs="12" md="2" className="mb-2">
                  <DatePicker
                    selected={endDate}
                    onChange={handleSearchfilterEndDate}
                    placeholderText="End Date"
                    dateFormat="DD/MM/YYYY"
                  />
                </Colxx>
                <Colxx xxs="12" md="1" className="mb-2">
                  <Button
                    color="primary"
                    className="mb-2"
                    onClick={() => { handleContacts(startDate, endDate); }}
                  >
                    Submit
                  </Button>
                </Colxx>
                {/* <Colxx xxs="12" md="5" className="mb-2"></Colxx>
                    <Colxx xxs="12" md="2" className="text-right mb-2">
                      <div className="search-sm d-inline-block mb-1 align-top">
                        <Input value={searchOrder} className="form-control" placeholder="Search" onChange={(e) => {
                          setSearchOrder(e.target.value);
                          LoadSearchOrderData(e.target.value, 'All');
                        }}></Input>     </div> 
                    </Colxx>*/}

              </Fragment>
            </Row>
            <CardBody>
              <Contact
                labels={dataTableColumnsContacts}
                data={contactStatsData}
                timeZone={propertyData.timeZone}
                propertyId={propertyId}
                height={50}
              />
            </CardBody>
          </Card>
        </TabPane>
      </TabContent>
      {showOrderData && (
        <ViewOrders
          isopen={showOrderData}
          toggle={() => {
            setShowOrderData(false);
          }}
          orderData={orderData}
        />
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings, oidc }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale, user: oidc.user,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));



